(function () {
  'use strict';

  angular.module('app').component('prepaymentReportList', prepaymentsReport());

  function prepaymentsReport() {
    return {
      bindings: {},
      controller: PrepaymentsReportComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/prepayment-reports/prepayment-report-list/prepayment-report-list.component.html',
    };
  }

  PrepaymentsReportComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'moment',
    'SessionService',
    'AbilityService',
    'TransactionReportService',
    'BookingService',
    'ReceivedPaymentService',
    'PaymentProviderService',

    // Angular downgraded service
    'companyService',
  ];

  function PrepaymentsReportComponent(
    config,
    UtilService,
    moment,
    SessionService,
    AbilityService,
    TransactionReportService,
    BookingService,
    ReceivedPaymentService,
    PaymentProviderService,

    // Angular downgraded service
    companyService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    vm.prepaymentType = angular.copy(config.PREPAYMENTS_TYPE);
    vm.prepaymentType.unshift({
      label: 'ALL',
      value: '',
    });

    vm.prepaymentStatus = angular.copy(config.PREPAYMENT_STATUSES);

    vm.bookingStatus = angular.copy(config.BOOKING_STATUS_PREPAYMENT);
    vm.bookingStatus.unshift({
      label: 'ALL',
      value: '', // it is sending the by_status=''
    });

    vm.isFormValid = true;

    const apiUrl = 'prepayment_reports';
    vm.urlXls = apiUrl + '/export_xls.xlsx';
    vm.urlPdf = apiUrl + '/export_pdf.pdf';
    vm.reportName = 'prepayments_report';

    vm.intitialDueDate = true;
    vm.incomingPrepaymentType = 'incoming'; // _prepayment
    vm.outgoingPrepaymentType = 'outgoing'; // _prepayment

    // private properties
    // -----------------------
    const companyId = SessionService.getSelectedAccountCompany().id;

    let mode = 'create';

    // const dateDisplay = config.DATE_DISPLAY_SHORT;

    let userLanguageCode = SessionService.getUserLanguage().code;
    let dateDisplay = userLanguageCode !== 'es' ? 'MM/DD/YYYY' : 'DD/MM/YYYY';

    const startDueDate = moment().subtract(3, 'years');

    // TODO: booking permissions ??
    vm.permissions = {
      canShow: AbilityService.can('show_booking_accountadmin'),
      canUpdate: AbilityService.can('update_booking_accountadmin'),
    };

    vm.$onInit = function () {
      setDefaultFilters();

      dueDatePicker();
      createdDatePicker();

      getReports();

      // Initializers
      getCompany();
    };

    // public methods
    // -----------------------
    vm.onSearched = function () {
      getReports();
    };

    vm.onSearchCleared = function () {
      vm.items = [];
      vm.meta = [];

      setDefaultFilters();
      getReports();
    };

    vm.onSort = function (sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;

      getReports();
    };

    vm.selectPage = function () {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      getReports();
    };

    vm.clearSearch = function () {
      vm.onSearchCleared();
    };

    vm.clearCreatedDate = function () {
      vm.createdDatePicker = {
        startDate: '',
        endDate: '',
      };

      delete vm.filterCriteria.created_at_start;
      delete vm.filterCriteria.created_at_end;
    };

    vm.showItem = function (item) {
      if (!vm.permissions.canShow) return;

      BookingService.openBookingInfoModal(item.booking.id);
    };

    vm.addPayment = function (prepayment, type) {
      let successCallback = function (response) {
        vm.items.map((item) => {
          if (item.id === prepayment.id) {
            if (type === vm.incomingPrepaymentType) {
              item.balance_due -= [...response.received_payment_documents].pop().amount;
              item.status = [
                ...response.received_payment_documents,
              ].pop().incoming_prepayment.status;
            } else {
              item.balance_due -= [...response.payment_provider_documents].pop().amount;
              item.status = [
                ...response.payment_provider_documents,
              ].pop().outgoing_prepayment.status;
            }
          }
        });
      };

      let createPayment = function (prepayment, type) {
        let payment = {
          currency_id: prepayment.booking.currency.id,
          currency: prepayment.booking.currency,
          user_id: prepayment.booking.user_id,
          amount: prepayment.balance_due,

          received_payment_document: {
            document_date: prepayment.due_date,
            document_id: prepayment.id,
            payment_date: prepayment.due_date,
            total_price: prepayment.amount,
            newBalance: 0,
            balance: prepayment.balance_due,
            number: prepayment.prepayment_consecutive,
            amount: prepayment.balance_due,
            type: type,
          },
          payment_provider_document: null,
        };

        // if (type === vm.incomingPrepaymentType) {
        // payment.client = prepayment.booking.client.id; // TODO: why .client.id ??
        // } else {
        // payment.provider = prepayment.provider
        // payment.provider_id = prepayment.provider.id

        if (type !== vm.incomingPrepaymentType) {
          payment.payment_provider_document = payment.received_payment_document;

          delete payment.received_payment_document;
        }

        return payment;
      };

      if (type === vm.incomingPrepaymentType) {
        prepayment.booking.client_id = prepayment.client.id;
        prepayment.booking.client = prepayment.client;

        ReceivedPaymentService.openItemReceivedPaymentModal(
          createPayment(prepayment, type),
          mode,
          vm.company,
          prepayment.booking,
          successCallback
        );
      } else {
        prepayment.booking.provider_id = prepayment.provider.id;
        prepayment.booking.provider = prepayment.provider;

        PaymentProviderService.openItemPaymentProviderModal(
          createPayment(prepayment, type),
          mode,
          vm.company,
          prepayment.booking,
          successCallback
        );
      }
    };

    // private methods
    // -----------------------
    let filterByDueDate = () => {
      vm.dueDateFrom = vm.dueDatePicker.startDate.format(dateDisplay);
      vm.dueDateTo = vm.dueDatePicker.endDate.format(dateDisplay);

      vm.intitialDueDate = startDueDate.format(dateDisplay) === vm.dueDateFrom ? true : false;

      vm.filterCriteria.by_due_date_from = vm.UtilService.startOfDayFormat(
        vm.dueDatePicker.startDate
      );
      vm.filterCriteria.by_due_date_to = vm.UtilService.endOfDayFormat(vm.dueDatePicker.endDate);
    };

    function setDefaultFilters() {
      vm.dueDatePicker = {
        startDate: moment().subtract(3, 'years'),
        endDate: moment(),
      };

      vm.createdDatePicker = {
        startDate: '',
        endDate: '',
      };

      vm.filterCriteria = TransactionReportService.getFilterCriteria('date', 'desc');

      vm.filterCriteria.by_type = vm.prepaymentType[0].value;
      vm.filterCriteria.by_booking_status = vm.bookingStatus[0].value;

      let prepaymentStatusPending = vm.prepaymentStatus.find(
        (prepayment) => prepayment.value === 'pending'
      ).value;
      let prepaymentStatusProcessing = vm.prepaymentStatus.find(
        (prepayment) => prepayment.value === 'processing'
      ).value;

      vm.filterCriteria['by_statuses[]'] = [prepaymentStatusPending, prepaymentStatusProcessing];

      filterByDueDate();
    }

    function dueDatePicker() {
      let dueDateOptions = config.DUE_DATE_OPTIONS;
      dueDateOptions['up_to_date'] = true;

      vm.dueDateOptions = vm.UtilService.datePickerOptions({
        filterBy: filterByDueDate,
        rangeOptions: dueDateOptions,
        dateDisplay: dateDisplay,
        startDate: startDueDate,
      });
    }

    function createdDatePicker() {
      let filterByCreatedDate = () => {
        vm.filterCriteria.created_at_start = vm.UtilService.startOfDayFormat(
          vm.createdDatePicker.startDate
        );
        vm.filterCriteria.created_at_end = vm.UtilService.endOfDayFormat(
          vm.createdDatePicker.endDate
        );
      };

      vm.createdDateOptions = vm.UtilService.datePickerOptions({
        filterBy: filterByCreatedDate,
        rangeOptions: config.CREATED_DATE_OPTIONS,
        dateDisplay: dateDisplay,
        opens: 'left',
      });
    }

    function getReports() {
      vm.filterCriteria.lang = userLanguageCode;

      vm.loadingReports = true;
      TransactionReportService.getTransactionsReport(vm.filterCriteria, apiUrl).then(function (
        data
      ) {
        vm.items = data.items;
        vm.meta = data.meta;

        // console.log(vm.items);

        vm.items.forEach((item) => {
          item.contact_name = contactName(item);
          item.due_date = moment(item.due_date).format(dateDisplay);
        });

        vm.loadingReports = false;
      });
    }

    function getCompany() {
      companyService
        .getCompany(companyId, { skip_check_role: true, lang: userLanguageCode })
        .subscribe((response) => {
          vm.company = response;
        });
    }

    function contactName(item) {
      let name;

      if (item.type === vm.incomingPrepaymentType) {
        name = item.commercial_name || `${item.client.name} ${item.client.last_name}`;
      } else {
        name = item.commercial_name || `${item.provider.name} ${item.provider.last_name}`;
      }

      return name;
    }
  }
})();
